export default "__VITE_ASSET__573f1f51__"